// @ts-nocheck
import React, { useEffect, useRef } from "react";
import { Box, Grid, Container, Slide, Tooltip } from "@mui/material";
import "reactjs-popup/dist/index.css";
import GridOnIcon from "@mui/icons-material/GridOn";
import { RightSidePanel } from "./Components/RightPanel/RightPanel.js";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import {
  GridDetailPanelToggleCell,
  GridNoRowsOverlay,
} from "@mui/x-data-grid-pro";
import { useTheme } from "../ThemeContext/ThemeContext.js";
import ArrowRight from "@mui/icons-material/ArrowRight";
import { useHistory, useLocation } from "react-router-dom";
import {
  BodyLarge,
  BodyMedium,
  BodySmall,
  H7TitleLarge,
  H8TitleMedium,
} from "../components/StyledComponents/Typography/Typography.tsx";
import { Popover, Stack } from "@mui/material";
import styled from "@emotion/styled";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import { useAuth0 } from "@auth0/auth0-react";
import { StyledDialog } from "../components/StyledComponents/Dialog/Dialog.js";
import CloseIcon from "@mui/icons-material/Close";
import { MinerTableOperationsContainer } from "./Components/Operations/MinerTableOperationsContainer.js";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { MinerTableHeader } from "./Components/MinerHeader/MinerHeader.js";
import useMinerPageContext from "./context/useMinerPageContext.js";
import DataGrid from "../components/DataGrid/DataGrid.tsx";
import {
  useQuery,
  useInfiniteQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { StyledIconButton } from "../components/StyledComponents/Buttons/AuradineButtons.js";
import {
  GetUserUseQuery,
  PostNewMinerDeviceCS,
  GetUserTechsupport,
} from "../api/api.js";
import {
  returnDefaultColumnConfigs,
  returnDefaultColumnConfigsForTable,
} from "./Utils/Utils.js";
import { first, isEmpty, rest, set } from "lodash";
import {
  SecondaryButton,
  StyledLabel,
} from "../components/StyledComponents/Buttons/AuradineButtons.js";
import { LeftSidePanel } from "./Components/LeftPanel/LeftPanel.js";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import StyledLinearProgress from "../components/StyledComponents/Progress/Progress.js";
import { StyledCheckbox } from "../components/StyledComponents/Inputs/Inputs.js";
import UntagMinersDialog from "./Components/UntagMiners/UntagMiners.js";
import useOrgSiteGroupTreeContext from "./context/useOrgSiteGroupTreeContext.js";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import JobsDialog from "./Components/JobsDialog/JobsDialog.js";
import PoolsDialog from "./Components/PoolDialog/PoolsDialog.js";
import PSUDialog from "./Components/PSUDialog/PSUDialog.js";
import FansDialog from "./Components/FansDialog/FansDialog.js";
import { format, parseISO, isValid } from "date-fns";
import { TagsListDialog } from "./Components/TagsListDialog/TagsListDialog.js";

export const HeaderContainer = React.memo((props) => {
  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="flex-start"
      flexDirection="column"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H7TitleLarge>
          Tech Support Miner Inventory
        </H7TitleLarge>
      </Box>
    </Box>
  );
});

const CompactedTagsList = (tagData) => {
  const { tags, data } = tagData;

  const {
    setSelectedSerials,
    selectedSerials,
    setCurrentSerial,
    currentSerial,
    setTagsListDialogOpen,
  } = useMinerPageContext();
  const { colors } = useTheme();
  const StyledPopover = styled(Popover)(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: "1rem", // Rounded corners
      backgroundColor: "#F3F2FD", // Background color
      boxShadow: theme.shadows[1], // Optional: Add a shadow
      padding: "1.5rem", // Optional: Add padding
    },
  }));

  if (!tags || tags.length === 0 || !Array.isArray(tags)) {
    return <BodyMedium> No tags to display</BodyMedium>;
  }
  if (tags && Array.isArray(tags) && tags.length <= 2) {
    return (
      <BodyMedium>
        {tags.map((item) => item).join(", ")}
      </BodyMedium>
    );
  }
  if (tags && Array.isArray(tags) && tags.length > 2) {
    const firstTwoTags = tags.slice(0, 2).join(", ");
    const restOfTags = [...tags.slice(2)];
    return (
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        gap={1}
        flexWrap={"wrap"}
        whiteSpace={"normal"}
        wordbreak={"break-word"}
        py={1.5}
      >
        <BodyMedium>{firstTwoTags}</BodyMedium>
        <SecondaryButton colors={colors}
          sx={{ "&:hover": { cursor: "pointer" } }}
          onClick={(event) => {
            // if (selectedSerial) {
            //   setSelectedSerials(selectedSerial);
            // }
            event.stopPropagation();
            setTagsListDialogOpen(true);
            setCurrentSerial(data);
          }}
        >
          +{tags.length - 2} more
        </SecondaryButton>
      </Box>
    );
  }
  return "";
};

const GetDetailPanelContent = ({
  row,
  history,
  detailGroup,
  setUnTagDialogOpen,
  setTagsListDialogOpen,
  setOpenJobsDialog,
  setJobs,
  setOpenPoolsDialog,
  setPoolsData,
  setOpenPSUDialog,
  setPsuData,
  setOpenFansDialog,
  setFansData,
  colors,
}) => {
  if (!row) return <> </>;
  if (isEmpty(detailGroup)) return <></>;
  const { SerialNo } = row;
  const columnsToShowWithData = row
    ? Object.entries(row)
        .filter(([key, value]) => {
          const columns = detailGroup
            ? detailGroup?.map((item) => item?.id)
            : [];
          return (
            columns.includes(key) && !Array.isArray(value)
          );
        })
        .reduce((acc, item) => {
          acc[item[0]] = item[1];
          return acc;
        }, {})
    : [];

  const columnsTitles = detailGroup
    ? detailGroup
        ?.filter((item) =>
          columnsToShowWithData
            ? Object.keys(columnsToShowWithData).includes(
                item.id
              )
            : false
        )
        .map((item) => item?.name)
    : [];

  const hasHashBoardsColumn = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("Hash Boards")
    : [];
  const hasJobsColumn = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("Jobs")
    : [];

  const hasPoolsColumn = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("Pools")
    : [];
  const hasPSUStatsColumn = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("PSU Stats")
    : [];
  const hasFanStatsColumn = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("Fan Stats")
    : [];
  const hasTagsColums = detailGroup
    ? detailGroup
        ?.map((item) => item?.name)
        .includes("Tags")
    : [];

  const pickUpTime = (value) => {
    let upTimeValue = "";
    let reportedTimeValue = "";

    if (!value) return "";

    const parts = value.split(",");

    // --- Uptime parsing ---
    const upTime = parts[2]?.substr(8) || "";
    let months = 0,
      days = 0,
      hours = 0,
      minutes = 0,
      seconds = 0;

    const monthMatch = upTime.match(/([\d.]+)mo/);
    const dayMatch = upTime.match(/([\d.]+)d/);
    const hourMatch = upTime.match(/([\d.]+)h/);
    const minuteMatch = upTime.match(/([\d.]+)m/);
    const secondMatch = upTime.match(/([\d.]+)s/);

    if (monthMatch) months = parseFloat(monthMatch[1]);
    if (dayMatch) days = parseFloat(dayMatch[1]);
    if (hourMatch) hours = parseFloat(hourMatch[1]);
    if (minuteMatch) minutes = parseFloat(minuteMatch[1]);
    if (secondMatch) seconds = parseFloat(secondMatch[1]);

    const MINUTES_IN_YEAR = 525600;
    const MINUTES_IN_MONTH = 43800;
    const MINUTES_IN_DAY = 1440;

    let totalMinutes =
      months * MINUTES_IN_MONTH +
      days * MINUTES_IN_DAY +
      hours * 60 +
      minutes +
      seconds / 60;

    const yearsOut = Math.floor(
      totalMinutes / MINUTES_IN_YEAR
    );
    totalMinutes %= MINUTES_IN_YEAR;

    const monthsOut = Math.floor(
      totalMinutes / MINUTES_IN_MONTH
    );
    totalMinutes %= MINUTES_IN_MONTH;

    const daysOut = Math.floor(
      totalMinutes / MINUTES_IN_DAY
    );
    totalMinutes %= MINUTES_IN_DAY;

    const hoursOut = Math.floor(totalMinutes / 60);
    totalMinutes %= 60;

    const minutesOut = Math.round(totalMinutes);

    const upTimeObj = {
      y: yearsOut,
      mo: monthsOut,
      d: daysOut,
      h: hoursOut,
      m: minutesOut,
    };

    const filteredUpTimeObj = {};
    for (const key in upTimeObj) {
      if (upTimeObj[key] > 0) {
        filteredUpTimeObj[key] = upTimeObj[key];
      }
    }

    if (Object.keys(filteredUpTimeObj).length > 0) {
      upTimeValue = `${Object.entries(filteredUpTimeObj)
        .map(([key, value]) => `${value}${key}`)
        .join(" ")}`;
    }

    // --- Reported time parsing (UTC to local, show only if not today) ---
    const reportedRaw = parts[0]
      ?.replace("Time:", "")
      .trim();
    if (reportedRaw) {
      try {
        const date = new Date(reportedRaw + " UTC");
        const now = new Date();

        const isToday =
          date.getFullYear() === now.getFullYear() &&
          date.getMonth() === now.getMonth() &&
          date.getDate() === now.getDate();

        if (!isToday && !isNaN(date)) {
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(
            2,
            "0"
          );
          const dd = String(date.getDate()).padStart(
            2,
            "0"
          );
          const hh = String(date.getHours()).padStart(
            2,
            "0"
          );
          const min = String(date.getMinutes()).padStart(
            2,
            "0"
          );
          reportedTimeValue = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
        }
      } catch (e) {
        reportedTimeValue = "";
      }
    }
    return `${upTimeValue}${
      reportedTimeValue ? ` (${reportedTimeValue})` : ""
    }`;
  };

  const detailPanelColumns = [
    ...columnsTitles,
    hasHashBoardsColumn ? "Hash Boards" : "",
    hasJobsColumn ? "Jobs" : "",
    hasPoolsColumn ? "Pools" : "",
    hasPSUStatsColumn ? "PSU Stats" : "",
    hasFanStatsColumn ? "Fan Stats" : "",
    hasTagsColums ? "Tags" : "",
  ];

  const detailedInfoWithColumnNames = columnsToShowWithData
    ? Object.entries(columnsToShowWithData).reduce(
        (acc, [key, value]) => {
          const columnTitle = detailGroup
            ? detailGroup?.filter(
                (item) => item?.id === key
              )[0]?.name
            : "";
          acc[columnTitle] = value;
          return acc;
        },
        {}
      )
    : {};

  const sortedDetailedInfoWithColumnNames = Object.keys(
    detailedInfoWithColumnNames
  )
    .sort()
    .reduce((acc, key) => {
      acc[key] = detailedInfoWithColumnNames[key];
      return acc;
    }, {});

  return (
    <Box paddingLeft={"5.7rem"} overflow={"visible"}>
      <Grid container spacing={2}>
        {sortedDetailedInfoWithColumnNames &&
          Array.isArray(
            Object.entries(
              sortedDetailedInfoWithColumnNames
            )
          ) &&
          Object.entries(
            sortedDetailedInfoWithColumnNames
          ).map(([key, value], index) => (
            <Grid item xs={4} key={index}>
              <Box
                display={"flex"}
                justifyContent={"center"}
                flexDirection={"column"}
                padding={"0.5rem 1.5rem 0.5rem 1rem"}
                minHeight={"4.5rem"}
              >
                <BodyLarge>{key}</BodyLarge>
                <BodyMedium>
                  {value ? (
                    key?.toLowerCase() ===
                    "warranty start date" ? (
                      `${
                        value && isValid(parseISO(value))
                          ? format(
                              parseISO(value),
                              "MM/dd/yyyy"
                            )
                          : ""
                      }`
                    ) : key?.toLowerCase() ===
                      "warranty end date" ? (
                      `${
                        value && isValid(parseISO(value))
                          ? format(
                              parseISO(value),
                              "MM/dd/yyyy"
                            )
                          : ""
                      }`
                    ) : key?.toLowerCase() ===
                      "hash updated at" ? (
                      `${
                        value && isValid(parseISO(value))
                          ? format(
                              parseISO(value),
                              "MM/dd/yyyy hh:mm a"
                            )
                          : ""
                      }`
                    ) : key?.toLowerCase() ===
                      "ip address" ? (
                      <a
                        href={`https://${value}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline", // force underline
                          color: colors?.text?.primary,
                          textDecorationColor: colors?.text?.primary,
                        }}
                        onClick={(event) =>
                          event.stopPropagation()
                        }
                      >
                        {value}
                      </a>
                    ) : key?.toLowerCase() ===
                      "power efficiency" ? (
                      `${value} J/THs`
                    ) : key?.toLowerCase() === "power" ? (
                      `${value} W`
                    ) : key?.toLowerCase() === "uptime" ? (
                      pickUpTime(value)
                    ) : key?.toLowerCase() ===
                      "hash rate" ? (
                      `${value} TH/s`
                    ) : (
                      value
                    )
                  ) : (
                    value
                  )}
                </BodyMedium>
              </Box>
            </Grid>
          ))}
        {detailPanelColumns?.includes("Tags") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              minHeight={"4.5rem"}
            >
              <BodyLarge>Tags</BodyLarge>
              <CompactedTagsList
                data={SerialNo}
                tags={row?.Tag ?? []}
                setTagsListDialogOpen={
                  setTagsListDialogOpen
                }
              />
            </Box>
          </Grid>
        )}

        {detailPanelColumns?.includes("Hash Boards") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              alignItems={"center"}
              minHeight={"4.5rem"}
              flexGrow={1}
              onClick={() => {
                history.push(
                  `/hashboardheatmapCS?serialNo=${SerialNo}`
                );
              }}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: colors?.hover?.muted,
                  borderRadius: "6.7rem",
                },
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                gap={4}
              >
                <GridOnIcon sx={{ color: colors?.text?.muted }} />
                <BodyLarge> Hash Boards</BodyLarge>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <ArrowRightIcon sx={{ color: colors?.text?.muted }} />
              </Box>
            </Box>
          </Grid>
        )}
        {detailPanelColumns?.includes("Jobs") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              minHeight={"4.5rem"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              flexGrow={1}
              onClick={() => {
                history.push(
                  `/minerjobsCS?serialNo=${SerialNo}`
                );
              }}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: colors?.hover?.muted,
                  borderRadius: "6.7rem",
                },
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                gap={4}
              >
                <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
                  work_history
                </span>
                <BodyLarge> Jobs</BodyLarge>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <ArrowRightIcon sx={{ color: colors?.text?.muted }} />
              </Box>
            </Box>
          </Grid>
        )}
        {detailPanelColumns?.includes("Pools") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              minHeight={"4.5rem"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              flexGrow={1}
              onClick={(event) => {
                event.stopPropagation();
                setOpenPoolsDialog((prev) => !prev);
                setPoolsData(row);
              }}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: colors?.hover?.muted,
                  borderRadius: "6.7rem",
                },
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                gap={4}
              >
                <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
                  pool
                </span>
                <BodyLarge> Pools</BodyLarge>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <ArrowRightIcon sx={{ color: colors?.text?.muted }} />
              </Box>
            </Box>
          </Grid>
        )}
        {detailPanelColumns?.includes("PSU Stats") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              minHeight={"4.5rem"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              flexGrow={1}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: colors?.hover?.muted,
                  borderRadius: "6.7rem",
                },
              }}
              onClick={() => {
                setOpenPSUDialog((prev) => !prev);
                setPsuData(row);
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                gap={4}
              >
                <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
                  power
                </span>
                <BodyLarge> PSU Stats</BodyLarge>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <ArrowRightIcon sx={{ color: colors?.text?.muted }} />
              </Box>
            </Box>
          </Grid>
        )}
        {detailPanelColumns?.includes("Fan Stats") && (
          <Grid item xs={4}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              minHeight={"4.5rem"}
              padding={"0.5rem 1.5rem 0.5rem 1rem"}
              flexGrow={1}
              sx={{
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: colors?.hover?.muted,
                  borderRadius: "6.7rem",
                },
              }}
              onClick={() => {
                setOpenFansDialog((prev) => !prev);
                setFansData(row?.FanStats);
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-start"}
                gap={4}
              >
                <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
                  mode_fan
                </span>
                <BodyLarge> Fan Stats</BodyLarge>
              </Box>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <ArrowRightIcon sx={{ color: colors?.text?.muted }} />
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

/**
 * Represents the MinerPage component.
 * This component displays a table of miner devices and provides functionality to interact with them.
 */
export default function CSMinerPage() {
  const [leftSidePanelOpen, setLeftSidePanelOpen] =
    React.useState(false);
  const [rightSidePanelOpen, setRightSidePanelOpen] =
    React.useState(false);
  const [selectionModel, setSelectionModel] =
    React.useState([]);
  const [gridHeight, setGridHeight] = React.useState(0);
  const [tableKey, setTableKey] = React.useState(0);
  const [
    paginationResetVersion,
    setPaginationResetVersion,
  ] = React.useState(0);
  const { colors } = useTheme();
  const [sortModel, setSortModel] = React.useState([]);
  const tableContainerRef = React.useRef(null);
  const history = useHistory();
  const location = useLocation();
  const gridRef = useRef(null);
  const queryClient = useQueryClient();
  const {
    setTableGroup,
    setDetailGroup,
    tableGroup,
    detailGroup,
    setSelectedSerials,
    groupFilters,
    setGroupFilters,
    openPoolsDialog,
    setOpenPoolsDialog,
    setPoolsData,
    setPsuData,
    setFansData,
    selectedSerials,
    setTagsListDialogOpen,
    tagsListDialogOpen,
    setJobs,
    openPSUDialog,
    setOpenPSUDialog,
    openFansDialog,
    setOpenFansDialog,
  } = useMinerPageContext();
  const [openJobsDialog, setOpenJobsDialog] =
    React.useState(false);
  // const [skip, setSkip] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const limit = 25;
  //fetching to get userPreferences to set the tableGroup and detailGroup from user object. If not present, we are setting default values
  const [authToken, setAuthToken] = React.useState("");
  const [queryRefreshVersion, setQueryRefreshVersion] =
    React.useState(0);
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const [validUser, setValidUser] = React.useState(-1);
  const {
    orgSelectedName,
    siteSelectedName,
    groupSelectedName,
    setSiteSelectedName,
    setGroupSelectedName,
    setOrgSelectedName,
  } = useOrgSiteGroupTreeContext();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const user = userInfo?.user;

  // React.useEffect(() => {
  //   setPaginationResetVersion((v) => v + 1);
  // }, [JSON.stringify(sortModel)]);

  useEffect(() => {
    const fn = async () => {
      const token = await getAccessTokenSilently();
      await GetUserTechsupport(token, (data) => {
        if (data.status === "error") {
          if (data.errorCode === 1007) {
            setValidUser(1);
          } else {
            setValidUser(1);
          }
        } else {
          setValidUser(0);
        }
      });
    };
    fn();
  }, [getAccessTokenSilently]);

  // useEffect to check if any saved preference for column placement. If not present, set default values for initial users.
  useEffect(() => {
    if (
      isUserInfoFetched &&
      user &&
      user?.newPreferenceCS
    ) {
      const newPreferenceCS = user?.newPreferenceCS;
      setTableGroup(newPreferenceCS?.tableGroup);
      setDetailGroup(newPreferenceCS?.detailGroup);
    } else if (
      isUserInfoFetched &&
      user &&
      !user?.newPreferenceCS
    ) {
      const defaultValuesForTableGroupAndDetailGroup =
        returnDefaultColumnConfigs();

      const { tableGroup, detailGroup } =
        defaultValuesForTableGroupAndDetailGroup;
      setTableGroup(tableGroup);
      setDetailGroup(detailGroup);
    }
  }, [isUserInfoFetched, user]);

  useEffect(() => {
    const defaultValuesForTableGroupAndDetailGroup =
      returnDefaultColumnConfigs();

    const { tableGroup, detailGroup } =
      defaultValuesForTableGroupAndDetailGroup;
    setTableGroup(tableGroup);
    setDetailGroup(detailGroup);
  }, []);

  // if user goes to another page, checks there are existing url params,
  // if not gets the latest filters from context and appends to url accordingly
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasParams = Array.from(params.keys()).length > 0;

    let filters = {};
    let siteGroupFilters = {};

    const paramKeys = [
      "CBSN",
      "chassis",
      "mac",
      "csTag",
      "fromIP",
      "maxPower",
      "maxUpTime",
      "maximumChipTemperature",
      "maximumHashRate",
      "maximumPowerEfficiency",
      "minPower",
      "minUpTime",
      "minimumChipTemperature",
      "minimumHashRate",
      "minimumPowerEfficiency",
      "mode",
      "model",
      "status",
      "toIP",
      "tuningConfiguration",
      "version",
      "sourceIP",
      "org_name",
      "siteName",
      "dgname",
    ];

    if (hasParams) {
      paramKeys.forEach((key) => {
        if (["status", "model", "mode"].includes(key)) {
          const values = params.getAll(key);
          if (values.length > 0) {
            filters[key] = values.map(String);
          }
        } else if (
          ["org_name", "siteName", "dgname"].includes(key)
        ) {
          const value = params.get(key);
          if (value) {
            siteGroupFilters[key] = value;
          }
        } else {
          const value = params.get(key);
          if (value) {
            filters[key] = value;
          }
        }
      });

      sessionStorage.setItem(
        "minerFiltersCS",
        JSON.stringify(filters)
      );
      setGroupFilters(filters);

      sessionStorage.setItem(
        "siteGroupCS",
        JSON.stringify(siteGroupFilters)
      );
      setOrgSelectedName(
        siteGroupFilters?.org_name
          ? siteGroupFilters.org_name
          : ""
      );
      setSiteSelectedName(
        siteGroupFilters?.siteName
          ? siteGroupFilters.siteName
          : ""
      );
      setGroupSelectedName(
        siteGroupFilters?.dgname
          ? siteGroupFilters.dgname
          : ""
      );
    } else {
      const newParams = new URLSearchParams();

      const savedFilters = sessionStorage.getItem(
        "minerFiltersCS"
      );
      if (savedFilters) {
        const storedFilters = JSON.parse(savedFilters);
        const fieldsThatShouldBeArrays = [
          "status",
          "model",
          "mode",
        ];

        Object.keys(storedFilters).forEach((key) => {
          if (fieldsThatShouldBeArrays.includes(key)) {
            if (!Array.isArray(storedFilters[key])) {
              storedFilters[key] = [storedFilters[key]];
            }
          }
        });

        setGroupFilters(storedFilters);

        for (const [key, val] of Object.entries(
          storedFilters
        )) {
          if (Array.isArray(val)) {
            val.forEach((v) => newParams.append(key, v));
          } else {
            newParams.set(key, val);
          }
        }
      }

      const savedSiteGroup =
        sessionStorage.getItem("siteGroupCS");
      if (savedSiteGroup) {
        const storedSiteGroup = JSON.parse(savedSiteGroup);
        setOrgSelectedName(
          savedSiteGroup?.org_name
            ? savedSiteGroup.org_name
            : ""
        );
        setSiteSelectedName(
          savedSiteGroup?.siteName
            ? savedSiteGroup.siteName
            : ""
        );
        setGroupSelectedName(
          savedSiteGroup?.dgname
            ? savedSiteGroup.dgname
            : ""
        );

        for (const [key, val] of Object.entries(
          storedSiteGroup
        )) {
          if (val !== "") {
            newParams.set(key, val);
          }
        }
      }

      window.history.replaceState(
        {},
        "",
        `${
          window.location.pathname
        }?${newParams.toString()}`
      );
    }
  }, [location.search]);

  // React.useEffect(() => {
  //   resetTableSelection();
  //   setTableKey(prev => prev + 1); // Force DataGrid to remount
  // }, [groupFilters, siteSelectedName, groupSelectedName,refe]);

  /**
   * Fetches miner devices using an infinite query. enables pagination and fetches data in pages.Caches and retries on error.
   *
   * @returns {{
   *    data: any,
   *    fetchNextPage: () => void,
   *    isFetchingNextPage: boolean,
   *    status: string,
   *    isFetched: boolean
   * }}
   */
  const {
    data,
    fetchNextPage,
    isFetchingNextPage,
    status,
    isFetched,
    refetch: minerPageRefetch,
    isRefetching: isMinerDataRefetching,
    isLoading: isMinerDataLoading,
    isError: isMinerDataError,
  } = useInfiniteQuery({
    queryKey: [
      "MinerDevices",
      siteSelectedName,
      groupSelectedName,
      orgSelectedName,
      groupFilters,
      Array.isArray(sortModel) && sortModel.length > 0
        ? `${sortModel[0]?.field}-${sortModel[0]?.sort}`
        : "nosort",
      // paginationResetVersion,
    ],
    queryFn: ({ pageParam = { skip: 0, limit } }) =>
      PostNewMinerDeviceCS({
        authToken,
        body: {
          device: { ...pageParam },
          filter: {
            siteName: siteSelectedName,
            dgname: groupSelectedName,
            org_name: orgSelectedName,
            ...groupFilters,
          },
          sort:
            Array.isArray(sortModel) && sortModel.length > 0
              ? {
                  type: sortModel[0]?.sort,
                  field: sortModel[0]?.field,
                }
              : {},
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && validUser === 0,
    staleTime: 0,
    keepPreviousData: false,
    gcTime: 0, // <-- VERY IMPORTANT: Clears cache immediately
    initialPageParam: { skip: 0, limit },
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.flatMap(
        (page) => page.docs
      ).length;
      const totalCount = lastPage?.count || 0;
      return totalFetched >= totalCount
        ? undefined
        : { skip: totalFetched, limit };
    },
  });
  const filterSignatureRef = useRef("");
  const getFilterSignature = () =>
    JSON.stringify({
      siteSelectedName,
      groupSelectedName,
      groupFilters,
    });

  const currentSignature = getFilterSignature();
  let tableData = [];
  if (
    data &&
    data.pages &&
    data.pages.length > 0
    // &&
    // currentSignature === filterSignatureRef.current
  ) {
    tableData = isFetched
      ? data.pages
          .filter((page) => page.docs)
          .flatMap((page, pageIndex) =>
            page.docs.map((item, index) => {
              // Generate a unique ID by combining the page index and the item index
              return {
                ...item,
                // rowNo: pageIndex * limit + index + 1,
                id: `${pageIndex} -${index}`,
              };
            })
          )
      : [];
  } else {
    tableData = [];
  }

  const CustomGridRowsOverlay = () => {
    if (
      tableData.length === 0 &&
      isFetched &&
      data !== undefined &&
      data.pages[0].status === "ok"
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          No data available
        </Box>
      );
    }
    if (
      isMinerDataError ||
      data === undefined ||
      (isFetched &&
        data.pages[0].status.toLowerCase() === "error")
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          <AuradineErrorState message="Oops!! Something went wrong!!" />
        </Box>
      );
    }
  };

  React.useEffect(() => {
    resetTableSelection();
    queryClient.removeQueries({
      queryKey: [
        "MinerDevices",
        authToken,
        siteSelectedName,
        groupSelectedName,
        groupFilters,
      ],
      exact: false,
    });
    filterSignatureRef.current = getFilterSignature();
    setTableKey((prev) => prev + 1); // Force DataGrid to remount
    setQueryRefreshVersion((prev) => prev + 1); // Force DataGrid to remount
  }, [
    JSON.stringify(groupFilters),
    siteSelectedName,
    groupSelectedName,
    authToken,
    minerPageRefetch,
  ]);

  // Function to handle scroll end event and fetch next page
  const handleScrollEnd = () => {
    if (!isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const downloadCSV = () => {
    const csvData = tableData.filter(
      (item) => selectedSerials.includes(item.SerialNo) // note: SerialNo (case-sensitive)
    );

    if (csvData.length === 0) {
      alert("No data to export.");
      return;
    }

    const headers = Object.keys(csvData[0]).filter(
      (key) => key !== "id"
    );

    // Create CSV rows
    const csvRows = [
      headers.join(","), // header row
      ...csvData.map((row) =>
        headers
          .map((header) => {
            const value = row[header];
            // Wrap in quotes if value contains commas or quotes
            if (typeof value === "string") {
              return `"${value.replace(/"/g, '""')}"`; // escape double quotes
            }
            if (typeof value === "object") {
              return `"${JSON.stringify(value).replace(
                /"/g,
                '""'
              )}"`; // escape double quotes
            }
            if (Array.isArray(value)) {
              return `"${value
                .join(",")
                .replace(/"/g, '""')}"`; // escape double quotes
            }
            return value;
          })
          .join(",")
      ),
    ];

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "selected_miners.csv");
    document.body.appendChild(link); // Firefox fix
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const columns = returnDefaultColumnConfigsForTable();
  const tableDetailColOrder =
    tableGroup.length > 0
      ? tableGroup?.map((item) => item?.id)
      : [];
  // Create a new array of columns sorted by the order in tableDetailColOrder
  // Create a new array of columns sorted by the order in tableDetailColOrder
  const sortedColumns = tableDetailColOrder
    .map((id) =>
      columns.find((column) => column?.field === id)
    )
    .filter((column) => column !== undefined)
    .map((column) => ({ ...column, hide: false })); // Remove undefined columns here

  // Add the rest of the columns to the new array and set their hide property to true
  const restOfColumns = columns
    .filter(
      (column) =>
        !tableDetailColOrder.includes(column?.field)
    )
    .map((column) => ({ ...column, hide: true })); // Ensure all non-included columns are hidden

  const finalColumns = [...sortedColumns, ...restOfColumns];
  const finalColumnsSetup = finalColumns.map((column) => {
    if (
      column?.headerName?.toLowerCase() === "tags" ||
      column?.headerName?.toLowerCase() === "hash boards" ||
      column?.headerName?.toLowerCase() === "jobs" ||
      column?.headerName?.toLowerCase() === "pools" ||
      column?.headerName?.toLowerCase() === "psu stats" ||
      column?.headerName?.toLowerCase() === "fan stats"
    ) {
      column.sortable = false;
    }
    column?.headerName?.toLowerCase() === "tags" &&
      (column.renderCell = (params) => {
        return (
          <CompactedTagsList
            data={params?.row?.SerialNo}
            tags={params?.row?.Tag}
          />
        );
      });
    column?.headerName?.toLowerCase() === "hash boards" &&
      (column.renderCell = (params) => {
        const serialNo = params?.row?.SerialNo;
        return (
          <SecondaryButton colors={colors}
            endIcon={<ArrowRightIcon fontSize="small" />}
            disabled={!serialNo}
            onClick={(event, params) => {
              event.stopPropagation();
              history.push(
                `/hashboardheatmapCS?serialNo=${serialNo}`
              );
            }}
          >
            See all
          </SecondaryButton>
        );
      });
    column?.headerName?.toLowerCase() === "jobs" &&
      (column.renderCell = (params) => {
        const serialNo = params?.row?.SerialNo;
        return (
          <SecondaryButton colors={colors}
            endIcon={<ArrowRightIcon fontSize="small" />}
            disabled={!serialNo}
            onClick={(event) => {
              history.push(
                `/minerjobsCS?serialNo=${serialNo}`
              );
            }}
          >
            See all
          </SecondaryButton>
        );
      });
    column?.headerName?.toLowerCase() === "pools" &&
      (column.renderCell = (params) => {
        const serialNo = params?.row?.SerialNo;
        let alivePool = null;
        const pools = [1, 2, 3];

        for (let i of pools) {
          const statusKey = `Pool${i}Status`;
          const urlKey = `Pool${i}URL`;
          const userKey = `Pool${i}User`;
          const protocolKey = `Pool${i}Protocol`;

          if (
            params.row[statusKey]?.toLowerCase?.() === "alive" &&
            params.row[urlKey] &&
            params.row[userKey]
          ) {
            alivePool = {
              status: params.row[statusKey],
              user: params.row[userKey],
              url: params.row[urlKey],
              protocol: params.row[protocolKey],
            };
            break;
          }
        }

        return (
          alivePool && alivePool.url && alivePool.user ? (
            <SecondaryButton colors={colors}
              sx={{
                textAlign: 'left',
                whiteSpace: 'normal',
                justifyContent: 'flex-start',
              }}
              endIcon={<ArrowRightIcon fontSize="small" />}
              disabled={!serialNo}
              onClick={(event) => {
                event.stopPropagation();
                setOpenPoolsDialog((prev) => !prev);
                setPoolsData(params.row);
              }}
            >
              <Tooltip
                title={
                  alivePool
                    ? (
                        <>
                          <BodySmall sx={{ color: "white", p: "2px" }}>
                            {`${alivePool.url} (${alivePool.protocol || "NA"})`}
                          </BodySmall>
                          <BodySmall sx={{ color: "white", p: "2px" }}>
                            {alivePool.user}
                          </BodySmall>
                        </>
                      )
                    : null
                }
                arrow
                placement="bottom"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  maxWidth="100%"
                >
                  <BodyMedium
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    {alivePool.user}
                  </BodyMedium>
                  <BodyMedium
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    {alivePool.url}
                  </BodyMedium>
                </Box>
              </Tooltip>
            </SecondaryButton>
          ) : (
            <SecondaryButton colors={colors}
              sx={{
                p: 1.5,
                textAlign: 'left',
                whiteSpace: 'normal',
                justifyContent: 'flex-start',
              }}
              endIcon={<ArrowRightIcon fontSize="small" />}
              disabled={!serialNo}
              onClick={(event) => {
                event.stopPropagation();
                setOpenPoolsDialog((prev) => !prev);
                setPoolsData(params.row);
              }}
            >
              See all
            </SecondaryButton>
          )
        );
    });
    column?.headerName?.toLowerCase() === "psu stats" &&
      (column.renderCell = (params) => {
        const serialNo = params?.row?.SerialNo;
        return (
          <SecondaryButton colors={colors}
            endIcon={<ArrowRightIcon fontSize="small" />}
            disabled={!serialNo}
            onClick={(event) => {
              event.stopPropagation();
              setOpenPSUDialog((prev) => !prev);
              setPsuData(params.row);
            }}
          >
            See all
          </SecondaryButton>
        );
      });
    column?.headerName?.toLowerCase() === "fan stats" &&
      (column.renderCell = (params) => {
        const serialNo = params?.row?.SerialNo;
        return (
          <SecondaryButton colors={colors}
            endIcon={<ArrowRightIcon fontSize="small" />}
            disabled={!serialNo}
            onClick={(event) => {
              event.stopPropagation();
              setOpenFansDialog((prev) => !prev);
              setFansData(params.row?.FanStats ?? []);
            }}
          >
            See all
          </SecondaryButton>
        );
      });
    column?.headerName?.toLowerCase() === "mode" &&
      (column.renderCell = (params) => {
        return (
          <Stack
            direction="row"
            gap={2}
            display="flex"
            alignItems="center"
            flexWrap="wrap"
          >
            <BodyLarge>
              {params?.row?.Mode === "custom"
                ? `${params?.row?.Mode},`
                : params?.row?.Mode}
            </BodyLarge>
            {params?.row?.Mode === "custom" &&
              (params?.row?.ModeTHs ? (
                <BodyMedium sx={{ whiteSpace: "nowrap" }}>
                  THs {params.row.ModeTHs}
                </BodyMedium>
              ) : params?.row?.ModePower ? (
                <BodyMedium sx={{ whiteSpace: "nowrap" }}>
                  Power {params.row.ModePower} W
                </BodyMedium>
              ) : null)}
            {params?.row?.ModeSleep === "on" ? (
              <BodyMedium sx={{ whiteSpace: "nowrap" }}>
                Sleep: {params.row.ModeSleep}
              </BodyMedium>
            ) : null}
          </Stack>
        );
      });
    column?.headerName?.toLowerCase() ===
      "hash updated at" &&
      (column.renderCell = (params) => {
        const lastHash = params?.row?.LastHashUpdateAt;
        let formatted = "";
        if (lastHash) {
          const parsedDate = parseISO(lastHash);
          if (isValid(parsedDate)) {
            formatted = format(
              parsedDate,
              "MM/dd/yyyy, hh:mm a"
            );
          } else {
            formatted = "";
          }
        }
        return <BodyLarge>{formatted}</BodyLarge>;
      });
    return column;
  });

  // Construct column visibility model
  const columnVisibilityModel = finalColumns.reduce(
    (acc, column) => {
      if (column?.field) {
        // Ensure column and field are defined
        acc[column.field] = !column.hide; // Set visibility based on the 'hide' property
      }
      return acc;
    },
    {}
  );
  const handleTableSelectionChange = (
    newSelectionModel
  ) => {
    if (
      newSelectionModel.length !== selectionModel.length
    ) {
      setSelectionModel(newSelectionModel);
      if (newSelectionModel.length === 0) {
        setSelectedSerials([]);
      } else {
        const serials = tableData
          .filter((item) =>
            newSelectionModel.includes(item.id)
          )
          .map((item) => item.SerialNo);
        setSelectedSerials(serials);
      }
    }
  };

  useEffect(() => {
    const newModel = tableData
      .filter((item) =>
        selectedSerials.includes(item.SerialNo)
      )
      .map((item) => item.id);

    const isDifferent =
      newModel.length !== selectionModel.length ||
      newModel.some((id, i) => id !== selectionModel[i]);

    if (isDifferent) {
      setSelectionModel(newModel);
    }
  }, [selectedSerials, tableData]);

  const resetTableSelection = () => {
    setSelectionModel([]);
    setSelectedSerials([]);
  };

  const rowIdColumn = [
    {
      field: "rowNo",
      headerName: "Row No",
      minWidth: 50,
      renderCell: (params) => {
        if (
          !params ||
          !params.api ||
          params.id === undefined
        ) {
          return "";
        }

        return (
          params?.api.getRowIndexRelativeToVisibleRows(
            params.id
          ) + 1
        );
      },
      sortable: false,
    },
  ];
  console.log(tableData);
  const dataGridProps = {
    ref: gridRef,
    rows: Array.isArray(tableData) ? tableData : [],
    columns: [...rowIdColumn, ...finalColumnsSetup],
    page: 0,
    pinnedColumns: {
      left: [
        "__detail_panel_toggle__",
        "__check__",
        "rowNo",
      ],
    },
    sortingMode: "server",
    loading:
      isFetchingNextPage ||
      isMinerDataLoading ||
      isMinerDataRefetching,

    columnVisibilityModel: { ...columnVisibilityModel },
    getDetailPanelHeight: () => "auto",
    getDetailPanelContent: ({ row }) =>
      GetDetailPanelContent({
        row,
        history,
        detailGroup,
        setTagsListDialogOpen,
        setOpenJobsDialog,
        setJobs,
        setOpenPoolsDialog,
        setPoolsData,
        setOpenPSUDialog,
        setPsuData,
        setOpenFansDialog,
        setFansData,
        colors,
      }),
    getRowId: (row) => row.id,
    paginationMode: "client",
    pagination: true,
    // pageSize: tableData.length,
    disableColumnMenu: true,
    disableColumnResize: true,
    checkboxSelection: true,
    disableSelectionOnClick: true,
    disableCellSelection: true,
    paginationModel: { page: 0, pageSize: totalCount },
    onSortModelChange: (model) => setSortModel(model),
    onPaginationModelChange: (model) =>
      console.log("Page changed:", model),
    pageSizeOptions: [2000, 5000],
    onRowsScrollEnd: handleScrollEnd,
    overlayNoRowsTemplate: "No data available",
    slots: {
      baseCheckbox: StyledCheckbox,
      loadingOverlay: () => <StyledLinearProgress colors={colors} />,
      detailPanelToggleCell: GridDetailPanelToggleCell,
      detailPanelExpandIcon: () => <ArrowDropDownIcon />,
      detailPanelCollapseIcon: () => <ArrowDropUp />,
      noRowsOverlay: CustomGridRowsOverlay,
    },
    slotProps: {
      detailPanelToggleCell: {
        detailPanelExpandIcon: <ArrowRight />,
        detailPanelCollapseIcon: <ArrowDropUp />,
      },
      // loadingOverlay: {
      //   variant: "linear-progress",
      //   noRowsVariant: "skeleton",
      //   sx: {
      //     backgroundColor: "#F3F2FD",
      //   },
      // },
    },

    hideFooterPagination: true,
    hideFooter: true,
    selectionModel: selectionModel,
    onRowSelectionModelChange: handleTableSelectionChange,
    getRowHeight: () => "auto",
  };

  //collecting the height of the table container so that the right side panel would have the same height as the table container.

  React.useEffect(() => {
    if (tableContainerRef.current) {
      setGridHeight(
        tableContainerRef?.current?.clientHeight
      );
    }
  }, [tableContainerRef]);

  if (validUser === 0) {
    return (
      //@ts-nocheck

      <PageWrapper>
        <HeaderContainer />

        <Grid
          container
          className={"miner-page-table-container"}
          display={"flex"}
          flexDirection={"row"}
          spacing={4}
          sx={{ transition: "all 0.3s ease-in-out" }}
        >
          <Grid
            ref={tableContainerRef}
            item
            xs={rightSidePanelOpen ? 9 : 12}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            <Box
              className={"miner-page-table"}
              display={"flex"}
              flexDirection={"row"}
              backgroundColor={colors?.background?.paper}
              padding={"0.75rem 0  0.75rem 0"}
              borderRadius={"1rem"}
              sx={{
                transition: "width 0.3s ease-in-out", // Smooth transition for width
              }}
            >
              <LeftSidePanel
                leftSidePanelOpen={leftSidePanelOpen}
                setLeftSidePanelOpen={setLeftSidePanelOpen}
                height={gridHeight}
                authToken={authToken}
                resetTableSelection={resetTableSelection}
              />
              <Box
                className={"table-container"}
                display={"flex"}
                flexDirection={"column"}
                padding={"0 0.75rem 0 0.75rem"}
                height={"auto"}
                minWidth={"0"}
                min
                gap={4}
                flex={3}
                flexShrink={1}
              >
                <MinerTableHeader
                  setRightSidePanelOpen={
                    setRightSidePanelOpen
                  }
                  rightSidePanelOpen={rightSidePanelOpen}
                  gridRef={tableContainerRef}
                  totalCount={totalCount}
                />
                <MinerTableOperationsContainer
                  setRightSidePanelOpen={
                    setRightSidePanelOpen
                  }
                  gridRef={tableContainerRef}
                  refetch={minerPageRefetch}
                  resetTableSelection={resetTableSelection}
                  downloadCSV={downloadCSV}
                  setTableKey={setTableKey}
                />
                <Box
                  className={"Datagrid-container"}
                  display={"flex"}
                  flexShrink={1}
                  flexGrow={1}
                >
                  <DataGrid
                    colors={colors}
                    key={tableKey}
                    config={dataGridProps}
                    height="calc(100vh - 19rem)"
                  />
                </Box>
              </Box>
            </Box>
          </Grid>
          {rightSidePanelOpen && (
            <Slide
              direction="left"
              in={rightSidePanelOpen}
              timeout={350}
            >
              <Grid
                item
                xs={rightSidePanelOpen ? 3 : 0}
                style={{
                  transition: "width 0.3s ease-in-out",
                  opacity: rightSidePanelOpen ? 1 : 0,
                }}
              >
                <RightSidePanel
                  rightSidePanelOpen={rightSidePanelOpen}
                  setRightSidePanelOpen={
                    setRightSidePanelOpen
                  }
                  height={gridHeight}
                  gridRef={tableContainerRef}
                />
              </Grid>
            </Slide>
          )}
        </Grid>
        <TagsListDialog
          open={tagsListDialogOpen}
          setOpen={setTagsListDialogOpen}
          refetch={minerPageRefetch}
        />
        <JobsDialog
          open={openJobsDialog}
          setOpen={setOpenJobsDialog}
        />
        <PoolsDialog
          open={openPoolsDialog}
          setOpen={setOpenPoolsDialog}
        />
        <PSUDialog
          open={openPSUDialog}
          setOpen={setOpenPSUDialog}
        />
        <FansDialog
          open={openFansDialog}
          setOpen={setOpenFansDialog}
        />
      </PageWrapper>
    );
  } else {
    return <PageWrapper />;
  }
}
